import repository from '@/repositories/repository'

export default baseUrl => {
    baseUrl = `${baseUrl}/supervisor`

    return {
        isSupervisor(usuarioId) {
            return repository.get(`${baseUrl}/is-supervisor/${usuarioId}`)
        },
    }
}